import React, { Component } from 'react'



function closeCurrentWindow() {
    window.close();
  }

class Logout extends Component {
    render() {
        return (
            <div>

                <section id="wrapper">
                    <div className="login-register" style={{ backgroundImage: "url(assets/images/back_AFX.png)" }}>
                        <div className="lgtop"><img src="assets/images/afxlogo.png" /></div>
                        <div className="login-box">

                            <div>
                                <div style={{ fontSize: "14px", color: "#fff" }}>

                                    <br />
                                    <br />

                                    <div class="otp-box">You have been logged out successfully.</div>
                                    <br />
                                    <p>If you like to login again, please go back to your email and click the link.</p>
                                </div>
                            </div>

                            {/* <div className="form-group text-center m-t-20">
                                <div className="col-md-8 offset-md-2">
                                    <button className="btn btn-logs btn-lg btn-block text-uppercase waves-effect waves-light" onClick={() => window.close()}>Close</button>
                                </div>
                            </div> */}

                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default Logout
